export default __webpack_public_path__ + "static/media/TheWorldBrazil_00.ab2e3da7.png";